import React, { useState } from "react";
import { Global } from "../helpers/Global";

export const SolicitarResetPassword = () => {
  const [email, setEmail] = useState("");
  const [mensaje, setMensaje] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("➡️ Enviando solicitud de reseteo de contraseña...");
    console.log("📧 Email ingresado:", email);
    console.log("🌐 Base URL:", window.location.origin);

    if (!email) {
      setMensaje("Por favor, introduce tu correo electrónico.");
      return;
    }

    try {
      const endpoint = Global.url + "usuarios/password/reset/request";
      const payload = {
        email,
        baseUrl: window.location.origin
      };

      console.log("🟡 Enviando a:", endpoint);
      console.log("📦 Payload:", payload);

      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      console.log("📬 Respuesta cruda:", res);

      const contentType = res.headers.get("content-type");
      if (!res.ok) {
        const errorText = await res.text();
        console.error("❌ Error HTTP:", res.status, errorText);
        setMensaje(`Error ${res.status}: ${errorText}`);
        return;
      }

      if (!contentType || !contentType.includes("application/json")) {
        console.error("❌ Respuesta no es JSON:", contentType);
        setMensaje("Respuesta inesperada del servidor");
        return;
      }

      const data = await res.json();
      console.log("✅ Respuesta JSON:", data);

      setMensaje(data.message || "Revisa tu correo para continuar.");
    } catch (error) {
      console.error("🔥 Error al solicitar reseteo:", error);
      setMensaje("Error al procesar la solicitud.");
    }
  };

  return (
    <div className="cambiar-contrasena">
      <h2 className="centrar-titulo">¿Olvidaste tu contraseña?</h2>
      <p>Introduce tu correo electrónico y te enviaremos un enlace para restablecerla.</p>

      {mensaje && <p className="rojo">{mensaje}</p>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn-login">Enviar enlace</button>
      </form>
    </div>
  );
};
